import React from "react";
import { RCCGrid } from "react-common-components";
import GaugeChart from "src/components/GaugeChart";
import * as Tooltip from "./styles";
import { ITooltipGaugeChart } from "./interface";
import WrapText from "../WrapText";

const TooltipGaugeChart: React.FC<ITooltipGaugeChart> = ({
	linesPreGauge,
	linesPosGauge,
	value,
	styleInlineFade,
	styleInlineContainer,
	onClick
}) => {

	if(!value)
		return null;

	return(
		<Tooltip.FadedWithSlideDiv styleInline={styleInlineFade}>
			<Tooltip.Container styleInline={styleInlineContainer} onClick={onClick}>
				<Tooltip.Title>
					<span>{value.title}</span>
					{value.subTitle && (
						<WrapText lineClamp={2}>{value.subTitle}</WrapText>
					)}
				</Tooltip.Title>
				{linesPreGauge}
				<RCCGrid styleInline="margin-top: 0.25rem">
					<GaugeChart
						max={100}
						min={0}
						value={value.percentage}
						label=" "
						color={value.color === null ? undefined : `#${value.color}`}
					/>
				</RCCGrid>
				{linesPosGauge}
			</Tooltip.Container>
		</Tooltip.FadedWithSlideDiv>
		
	);};

export default TooltipGaugeChart;
